import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PushStatelessResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CbcStatelessPushService {
  constructor(private http: HttpClient) {}

  private buildParams(ssoId: string): HttpParams {
    let p = new HttpParams();
    if (ssoId) p = p.set('sso_id', ssoId);
    return p;
  }

  pushStatelessData(
    baseUrl: string,
    ssoId: string
  ): Observable<PushStatelessResponse> {
    const url = `${baseUrl}/saveJsonObject?action_id=32613`;
    const body = this.buildParams(ssoId).toString();
    return this.http.post<PushStatelessResponse>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
